// extracted by mini-css-extract-plugin
module.exports = {"splashAnimWave":"animations_splashAnimWave__3AjU3","splash":"animations_splash__3TzUq","takeBaitAnim":"animations_takeBaitAnim__2dvxQ"};